import { scrollToSection } from "utils/scrollToSection";

interface Project {
    id: string;
    title: string;
    sphere: string;
    problem?: string;
    solution: string;
    result: string;
    image: string;
    gradient: string;
    ctaText?: string;
    technologies?: string[]; // оставляем массив для удобства
    link?: string;
}

const projects: Project[] = [
    {
        id: "p1",
        title: 'Оздоровительный массаж в Кемерово',
        sphere: 'Здоровье / Услуги',
        problem: 'Создать сайт-визитку с возможностью быстрой записи на массаж и отображения прайс-листа.',
        solution: 'MVP на React и адаптивная верстка для корректного отображения на всех устройствах.',
        result: 'Клиент получил современный сайт, который корректно отображается на всех устройствах и генерирует заявки с мобильных телефонов.',
        image: require('../../assets/img/www.massage142.ru.png'),
        gradient: 'linear-gradient(to right, #9333ea, #2563eb)',
        ctaText: 'Посмотреть проект',
        technologies: ['React', 'CRA'], // преобразуем строку в массив при добавлении
        link: 'https://www.massage142.ru/',
    },
    {
        id: "p2",
        title: 'Торговое оборудование в Кемерово',
        sphere: 'Ритейл / Производство',
        problem: 'Показать ассортимент продукции (витрины, стеллажи) с качественными фотографиями и понятным описанием.',
        solution: 'Создание галереи работ на базе React для быстрой загрузки изображений и плавной навигации.',
        result: 'Повышение доверия клиентов за счет наглядной демонстрации качества продукции, что привело к увеличению числа целевых обращений.',
        image: require('../../assets/img/www.vitrina142.ru.png'),
        gradient: 'linear-gradient(to right, #9333ea, #2563eb)',
        ctaText: 'Посмотреть проект',
        technologies: ['React', 'CRA'], // преобразуем строку в массив при добавлении
        link: 'https://www.vitrina142.ru/',
    },
    // другие проекты...
];

const Projects = () => {
    return (
        <section id="projects" className="section section-dark">
            <div className="container">
                {/* Адаптированный Header */}
                <div className="section-header">
                    <div className="section-badge">Кейсы и результаты</div>
                    <h2>
                        Реальные <span className="title-accent">проекты</span> для реального бизнеса
                    </h2>
                    <p className="description">
                        Здесь собраны примеры работ из разных сфер.
                    </p>
                    {/* <p className="description">
                        Каждый проект решает конкретную задачу бизнеса: от запуска онлайн-услуг до автоматизации продаж.
                    </p> */}
                    <p className="description">
                        Проекты, которые можно реализовать как быстрый MVP для проверки идеи или как масштабируемый продукт для роста.
                    </p>
                </div>

                <div className="cards-grid">
                    {projects.map((project) => (
                        <div key={project.id} className="project-card">
                            <div className="project-image">
                                <img src={project.image} alt={project.title} />
                                <div className="project-category">{project.sphere}</div>
                            </div>
                            <div className="project-content">
                                {/* Адаптированный заголовок */}
                                <h3>{project.title}</h3>
                                {/* Адаптированное описание */}
                                <p>
                                    <span className="title-accent">Задача:</span> {project.problem}
                                    {/* Можно добавить детали реализации, если они есть */}
                                </p>
                                <p>
                                    <span className="title-accent">Решение:</span> {project.solution}
                                    {/* Можно добавить детали реализации, если они есть */}
                                </p>
                                <p>
                                    <span className="title-accent">Результат:</span> {project.result}
                                    {/* Можно добавить детали реализации, если они есть */}
                                </p>
                                {project.technologies && (
                                    <div className="project-tags">
                                        {project.technologies.map((tech, idx) => (
                                            <span key={idx} className="project-tag">{tech}</span>
                                        ))}
                                    </div>
                                )}
                                {project.link ? (
                                    <a
                                        href={project.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="project-cta"
                                        style={{ background: project.gradient }}
                                    >
                                        {project.ctaText || 'Посмотреть проект'}
                                        {/* Иконка SVG остается без изменений */}
                                    </a>
                                ) : (
                                    <button
                                        className="project-cta"
                                        style={{ background: project.gradient }}
                                        onClick={() => scrollToSection('contact')}
                                    >
                                        {project.ctaText || 'Подробнее'}
                                        {/* Иконка SVG остается без изменений */}
                                    </button>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {/* Футер блока остается без изменений */}
                <div
                    style={{
                        marginTop: '4rem',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '1rem',
                    }}
                >
                    <button type="button" onClick={() => scrollToSection('principles')} className="btn-primary">
                        Готовы создать что-то великое?
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Projects;
